// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"81306816","455":"a03e1eca","521":"67e9b85b","977":"06305ecb"}[chunkId] + ".chunk.js";
};